import type ButtonI from '$interfaces/misc/button.interface';
import { getItemPrice, linkFromItem, parseAgentClass, strapiImage } from '$lib/utils';

import types from '$lib/item-type-props';

import type ListConfigI from '$interfaces/misc/list-config.interface';

export default (data): ListConfigI => {
  const baseUrl = `/skins/agents`;

  let buttons: ButtonI[] = [
    {
      text: `Most Expensive Agents`,
      link: '/skins/agents/most-expensive',
      icon: 'face-tongue-money',
    },
    { text: `Cheapest Agents`, link: '/skins/agents/cheapest', icon: 'coin' },
    {
      text: 'CT Agents',
      link: '/skins/agents/counter-terrorists',
      icon: '/assets/binds-generator/ct.png',
      alt: 'Counter-Terrorist team icon',
    },
    {
      text: 'T Agents',
      link: '/skins/agents/terrorists',
      icon: '/assets/binds-generator/t.png',
      alt: 'Terrorist team icon',
    },
    {
      text: 'Collections',
      properties: {
        dropdown: true,
        options: data.collections.map((col) => ({
          text: col.name,
          icon: 'treasure-chest',
          link: `/skins/collections/${col.slug}`,
          count: `${col.lootlists[0].items.count} agents`,
          image: col.image,
        })),
      },
    },
  ];

  if (data.category) {
    buttons.push({
      text: 'All Agents',
      link: '/skins/agents',
      properties: { highlighted: true },
    });
    buttons = buttons.filter((btn) => !btn.link || btn.link.split('/').pop() !== data.category.slug);
  }

  return {
    itemType: 'Agents',
    relationKey: 'agent',
    listSizeCount: data.itemsTotal,
    rarityKey: 'character',
    jumbo: {
      title: `${data.category ? data.category.formattedName || data.category.name : 'All'} CS2 Agents`,
      text: `Find below a list of CS2 agents.`,
      image: data.category ? undefined : ['/assets/binds-generator/t.png', '/assets/binds-generator/ct.png'],
      extraText:
        'Click the "Card" and "Table" buttons to change the way agents are displayed. Use the buttons below to filter between agent categories including counter-terrorist, terrorist and agents from individual collections.',
      imagePosition: 'top-left',
      buttons,
      ...(data.category?.jumbo || {}),
    },
    sort: data.sort || null,
    itemLink: linkFromItem,
    pagination: {
      current: data.page || 1,
      link: baseUrl,
    },
    card: types.agent,
    meilisearch: {
      type: 'agent',
    },
    table: {
      columns: [
        {
          label: 'Collection',
          value: (item) => item.inLootlists.find((ll) => ll.collection)?.collection,
          preset: 'collection',
          width: 20,
          modifiers: ['w-justify-center', 'w-center', 'w-1200-100'],
          order: 5,
        },
      ],
    },
  };
};
